


























import {Component, Inject, Vue} from 'vue-property-decorator';
import Revenue from "@/components/operations/Revenue.vue";
import StoreVisits from "@/components/operations/StoreVisits.vue";
import Worksheet from "@/components/operations/Worksheet.vue";
import {Permissions} from "@/types";

Vue.component("v-revenue", Revenue);
Vue.component("v-store-visits", StoreVisits);
Vue.component("v-worksheet", Worksheet);

@Component
export default class Operations extends Vue {

    @Inject("hasPermission")
    hasPermission: Function;

    Permission = Permissions;
}
